// List of client codes that should default to manual Roll No entry

export const MANUAL_ROLLNO_CLIENTS = ["vbp", "hbis"]; 